import { render, staticRenderFns } from "./marquee-with-text.vue?vue&type=template&id=69e739e8&"
import script from "./marquee-with-text.vue?vue&type=script&lang=js&"
export * from "./marquee-with-text.vue?vue&type=script&lang=js&"
import style0 from "./marquee-with-text.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports